<template>
  <div class="loading_overlay" v-if="isLoading.single" />
  <div class="w-full min-h-screen md:flex text-white" v-else>
    <div class="relative lg:w-96 md:w-72">
      <div ref="sidebar" class="md:fixed top-0 left-0 pt-16 lg:w-96 md:w-72">
        <div class="border-r border-gray-700 h-full relative md:min-h-screen">
          <div
            class="flex flex-col items-center justify-center border-b  border-gray-700 px-2 pt-3"
          >
            <img
              :src="imageUrl(data['profile_path'])"
              :alt="data['name']"
              class="md:w-64 md:h-72 w-16 h-16 rounded-full"
            />
            <h1 class="text-xl my-3 text-center">{{ data["name"] }}</h1>
            <socials :externalIds="data.external_ids" />
          </div>
          <div class="py-4 px-2">
            <personal-info :data="data" />
          </div>
        </div>
      </div>
    </div>
    <div class="flex-1 w-full md:pt-16 pt-2">
      <header class="px-3 border-b border-gray-700">
        <h1 class="text-4xl py-2">{{ data["name"] }}</h1>
      </header>
      <section class="px-3 pt-2">
        <p>
          {{ data["biography"] }}
        </p>
        <div class="p-4 pt-8">
          <credits :data="data" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watch, onUnmounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import PersonalInfo from "./Partials/PersonalInfo.vue";
import Socials from "./Partials/Socials.vue";
import Credits from "./Partials/Credits.vue";
export default {
  components: { PersonalInfo, Credits, Socials },
  setup() {
    const store = useStore();
    const route = useRoute();
    const sidebar = ref();

    let data = computed(() => store.state["tmdbApi"].celebDetails);
    let isLoading = computed(() => store.state["tmdbApi"].isLoading);

    const handleScroll = () => {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;

      if (scrollValue < 61) {
        sidebar.value.style.paddingTop = `${61 - scrollValue}px`;
      } else {
        sidebar.value.style.paddingTop = `0px`;
      }
    };

    onMounted(() => {
      document.addEventListener("scroll", handleScroll);

      store.dispatch("tmdbApi/fetchCelebDetails", route.params.id);
    });

    onUnmounted(() => {
      document.removeEventListener("scroll", handleScroll);
    });

    watch(
      () => route.params.id,
      async id => {
        await store.dispatch("tmdbApi/fetchSingleMovie", id);
      }
    );

    return {
      data,
      isLoading,
      sidebar
    };
  }
};
</script>

<style></style>
